import React from "react";
import { map } from "lodash";
import { useAllPanels, useClosePanel } from "@radarly/core/panel/use-cases";
import { Panel } from "@radarly/models/panel";

interface IProps {
  children: (panel: Panel, close: () => void) => React.ReactNode;
}

const RadarlySharedPanel = ({ children }: IProps) => {
  const panels = useAllPanels();
  const closePanel = useClosePanel();
  return panels.length ? (
    <>
      {map(panels, (panel, idx) => (
        <React.Fragment key={idx}>
          {children(panel, () => closePanel(panel.type))}
        </React.Fragment>
      ))}
    </>
  ) : null;
};

export default RadarlySharedPanel;
